export default "/images/98afe9c9d894e4adf7cc4cfaf38ddc32.png";